// tslint:disable:max-file-line-count
import { TCategory } from '@cian/api-models/offer-card/v1/get-offer-data';

export type FieldNameType =
  | 'totalArea'
  | 'livingArea'
  | 'kitchenArea'
  | 'roomArea'
  | 'landStatus'
  | 'landArea'
  | 'buildMaterialType'
  | 'buildYear'
  | 'deadline'
  | 'floorNumber'
  | 'floorsCount'
  | 'isOccupied'
  | 'classType'
  | 'ceilingHeight'
  | 'columnGrid'
  | 'garageType'
  | 'parkingType'
  | 'propertyType'
  | 'landStatus'
  | 'commercialLandType';

export type TFieldContent =
  | 'area'
  | 'deadline'
  | 'text'
  | 'floorNumber'
  | 'landStatus'
  | 'buildMaterialType'
  | 'houseLandArea'
  | 'landArea'
  | 'classType'
  | 'occupied'
  | 'commercialFloorsCount'
  | 'ceilingHeight'
  | 'commercialLandType'
  | 'commercialArea';

export type FieldType = {
  name: FieldNameType;
  title: string;
  type: TFieldContent;
};
export type descriptionConfigType = { [index in TCategory]?: FieldType[] };

const totalArea = {
  name: 'totalArea' as FieldNameType,
  title: 'Общая',
  type: 'area' as TFieldContent,
};

const livingArea = {
  name: 'livingArea' as FieldNameType,
  title: 'Жилая',
  type: 'area' as TFieldContent,
};

const kitchenArea = {
  name: 'kitchenArea' as FieldNameType,
  title: 'Кухня',
  type: 'area' as TFieldContent,
};

const roomArea = {
  name: 'roomArea' as FieldNameType,
  title: 'Комната',
  type: 'area' as TFieldContent,
};

const landStatus = {
  name: 'landStatus' as FieldNameType,
  title: 'Статус земли',
  type: 'landStatus' as TFieldContent,
};

const landArea = {
  name: 'landArea' as FieldNameType,
  title: 'Площадь',
  type: 'landArea' as TFieldContent,
};

const houseLandArea = {
  name: 'landArea' as FieldNameType,
  title: 'Участок',
  type: 'landArea' as TFieldContent,
};

const buildMaterialType = {
  name: 'buildMaterialType' as FieldNameType,
  title: 'Тип дома',
  type: 'buildMaterialType' as TFieldContent,
};

const buildYear = {
  name: 'buildYear' as FieldNameType,
  title: 'Построен',
  type: 'text' as TFieldContent,
};

const deadlineYear = {
  name: 'deadlineYear' as FieldNameType,
  title: 'Срок сдачи',
  type: 'deadline' as TFieldContent,
};

const floorNumber = {
  name: 'floorNumber' as FieldNameType,
  title: 'Этаж',
  type: 'floorNumber' as TFieldContent,
};

const floorsCount = {
  name: 'floorsCount' as FieldNameType,
  title: 'Этажей в доме',
  type: 'text' as TFieldContent,
};

const columnGrid = {
  name: 'columnGrid' as FieldNameType,
  title: 'Сетка колонн',
  type: 'text' as TFieldContent,
};

const commercialArea = {
  name: 'totalArea' as FieldNameType,
  title: 'Площадь',
  type: 'commercialArea' as TFieldContent,
};

const commercialBuildYear = {
  name: 'buildYear' as FieldNameType,
  title: 'Год постройки',
  type: 'text' as TFieldContent,
};

const commercialFloorsCount = {
  name: 'floorsCount' as FieldNameType,
  title: 'Этажность',
  type: 'commercialFloorsCount' as TFieldContent,
};

const occupied = {
  name: 'isOccupied' as FieldNameType,
  title: 'Помещение',
  type: 'occupied' as TFieldContent,
};

const classType = {
  name: 'classType' as FieldNameType,
  title: 'Класс',
  type: 'classType' as TFieldContent,
};

const ceilingHeight = {
  name: 'ceilingHeight' as FieldNameType,
  title: 'Выс. потолков',
  type: 'ceilingHeight' as TFieldContent,
};

const garageType = {
  name: 'garageType' as FieldNameType,
  title: 'Тип',
  type: 'text' as TFieldContent,
};

const parkingType = {
  name: 'parkingType' as FieldNameType,
  title: 'Парковка',
  type: 'text' as TFieldContent,
};

const propertyType = {
  name: 'propertyType' as FieldNameType,
  title: 'Тип недвижимости',
  type: 'text' as TFieldContent,
};

const commercialLandType = {
  name: 'commercialLandType' as FieldNameType,
  title: 'Категория',
  type: 'commercialLandType' as TFieldContent,
};

const houseConfig: FieldType[] = [totalArea, houseLandArea, buildMaterialType, floorsCount, buildYear];

const bedRentConfig: FieldType[] = [kitchenArea, roomArea, floorNumber, buildYear];

const roomConfig: FieldType[] = [kitchenArea, roomArea, floorNumber, buildYear];

const flatConfig: FieldType[] = [totalArea, livingArea, kitchenArea, floorNumber, buildYear];

const landSaleConfig: FieldType[] = [landArea, landStatus];

const newBuildingFlatSaleConfig: FieldType[] = [totalArea, livingArea, kitchenArea, floorNumber, deadlineYear];

const warehouseAndIndustryConfig: FieldType[] = [commercialArea, floorNumber, columnGrid, ceilingHeight, occupied];

/**
 * Для офиса, ПСН, быт. услуг, автосервисов и общепита выводится один и тот же шаблон.
 */
const universalCommercialInfo: FieldType[] = [commercialArea, floorNumber, occupied, classType];
const officeConfig: FieldType[] = universalCommercialInfo;
const freeAppointmentObjectConfig: FieldType[] = universalCommercialInfo;
const carServiceConfig: FieldType[] = universalCommercialInfo;
const publicCateringConfig: FieldType[] = universalCommercialInfo;
const domesticServicesConfig: FieldType[] = universalCommercialInfo;

const shoppingAreaConfig: FieldType[] = [commercialArea, floorNumber, occupied, classType];

const buildingConfig: FieldType[] = [commercialArea, commercialFloorsCount, classType, commercialBuildYear];

const garageConfig: FieldType[] = [commercialArea, parkingType, garageType];

const businessConfig: FieldType[] = [commercialArea, floorNumber, propertyType];

const commercialLandConfig: FieldType[] = [landArea, commercialLandType];

export const descriptionConfig: descriptionConfigType = {
  bedRent: bedRentConfig,
  buildingRent: buildingConfig,
  buildingSale: buildingConfig,
  businessRent: businessConfig,
  businessSale: businessConfig,
  carServiceRent: carServiceConfig,
  carServiceSale: carServiceConfig,
  commercialLandRent: commercialLandConfig,
  commercialLandSale: commercialLandConfig,
  cottageRent: houseConfig,
  cottageSale: houseConfig,
  dailyBedRent: bedRentConfig,
  dailyFlatRent: flatConfig,
  dailyHouseRent: houseConfig,
  dailyRoomRent: roomConfig,
  domesticServicesRent: domesticServicesConfig,
  domesticServicesSale: domesticServicesConfig,
  flatRent: flatConfig,
  flatSale: flatConfig,
  flatShareSale: flatConfig,
  freeAppointmentObjectRent: freeAppointmentObjectConfig,
  freeAppointmentObjectSale: freeAppointmentObjectConfig,
  garageRent: garageConfig,
  garageSale: garageConfig,
  houseRent: houseConfig,
  houseSale: houseConfig,
  houseShareRent: houseConfig,
  houseShareSale: houseConfig,
  industryRent: warehouseAndIndustryConfig,
  industrySale: warehouseAndIndustryConfig,
  landSale: landSaleConfig,
  newBuildingFlatSale: newBuildingFlatSaleConfig,
  officeRent: officeConfig,
  officeSale: officeConfig,
  publicCateringRent: publicCateringConfig,
  publicCateringSale: publicCateringConfig,
  roomRent: roomConfig,
  roomSale: roomConfig,
  shoppingAreaRent: shoppingAreaConfig,
  shoppingAreaSale: shoppingAreaConfig,
  townhouseRent: houseConfig,
  townhouseSale: houseConfig,
  warehouseRent: warehouseAndIndustryConfig,
  warehouseSale: warehouseAndIndustryConfig,
};
